export default __webpack_public_path__ + "static/stacked-column-de13313f93fec1ab8b90e276876c1987.png";